import React from 'react';

const JS_Class_Static = () => {
  return (
    <div >
      <h1>JS_Class_Static</h1>
      <p>Placeholder component for: "JS Class Static"</p>
    </div>
  );
};

export default JS_Class_Static;
